<template>
<div class="MStepTwo">
    <div class="content_warp">
        <div class="card">
            <div @click="activeCard = item.code" class="card_item" :class="{'card_item': true, 'active': activeCard === item.code}" v-for="(item, index) in cardData" :key="index">{{item.name}}</div>
        </div>
    </div>
    <div class="btn_box">
        <div @click="upStep" class="up_btn">上一步</div>
        <div @click="nextStep" class="next_btn">下一步</div>
    </div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {Toast} from 'vant'
export default {
    name: 'MStepTwo',
    data() {
        return {
            cardData: [
                // {id:1, text: '股权激励'},
                // {id:2, text: '股权融资'},
                // {id:3, text: '企业并购'}
            ],
            activeCard: ''
        }
    },
    mounted() {},
    methods: {
        getCardData(data) {
            // console.log('第二步：', data);
            this.cardData = data
        },
        // 上一步
        upStep() {
            this.$emit('setStepValue', 0)
        },
        // 下一步
        nextStep() {
            // console.log(this.activeCard)
            if (this.activeCard === '') {
                Toast('请选择估值方法')
            } else {
                this.$emit('setTypeValue', this.activeCard)
                this.$emit('setStepValue', 2)
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss">
.MStepTwo {
    padding-bottom: 0.8rem;
    padding: 0.32rem;
    background-color: #fff;
    // height: 8rem;
    min-height: calc(100vh - 5rem);
    .card {
        .card_item {
            font-size: 0.32rem;
            height: 0.7rem;
            line-height: 0.7rem;
            text-align: center;
            // box-sizing: border-box;
            border: 0.01rem solid #409EFF;
            color: #409EFF;
        }
        .card_item + .card_item {
            margin-top: 0.32rem;
        }
        .card_item.active {
            background-color: #409EFF;
            color: #FFF;
        }

    }
    .btn_box {
        position: fixed;
        bottom: 0;
        left: 0;
        display: flex;
        width: 100vw;
        &>div {
            width: 50vw;
            height: 0.8rem;
            line-height: 0.8rem;
            text-align: center;
            font-size: 0.32rem;
            background-color: #E5E5E5;
            color: #666;
        }
        .next_btn {
            background-color: #409EFF;
            color: #fff;
        }
    }
}
</style>